import { FC } from 'react';

import { CardProductId, CreditCard } from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';

import CardLimit from './components/CardLimit';
import locales from './locales';

interface CardLimitsProps {
  creditCard: CreditCard;
  isEditable?: boolean;
}

const CardLimits: FC<CardLimitsProps> = ({ creditCard, isEditable }) => {
  const {
    cardProductId,
    creditCardId,
    isPhysical,
    limitAtmMonth,
    limitPaymentAll,
    limitPaymentWeek,
    totalAtmMonth,
    totalPaymentAll,
    totalPaymentWeek,
  } = creditCard;

  const isBudget = cardProductId === CardProductId.Budget;

  const paymentLimitComponent = (
    <CardLimit
      iconName="card-recto"
      isEditable={isEditable}
      limitAmount={limitPaymentWeek}
      ratioDescription={locales.paymentLimit}
      title={locales.editPaymentLimit}
      to={`/cards/${creditCardId}/payment-limit`}
      usedAmount={totalPaymentWeek}
    />
  );

  const paymentLimitAllComponent = (
    <CardLimit
      iconName="card-recto"
      isEditable={false}
      limitAmount={limitPaymentAll}
      ratioDescription={locales.paymentLimit}
      title={locales.editPaymentLimitAll}
      to={`/cards/${creditCardId}/payment-limit-all`}
      usedAmount={totalPaymentAll}
    />
  );

  if (isBudget) {
    return paymentLimitAllComponent;
  }

  if (!isPhysical) {
    return paymentLimitComponent;
  }

  const atmLimitComponent = (
    <CardLimit
      iconName="cash"
      isEditable={isEditable}
      limitAmount={limitAtmMonth}
      ratioDescription={locales.atmLimit}
      title={locales.editAtmLimit}
      to={`/cards/${creditCardId}/atm-limit`}
      usedAmount={totalAtmMonth}
    />
  );

  return (
    <SunshineCard.Group isBoxed={false}>
      {paymentLimitComponent}
      {atmLimitComponent}
    </SunshineCard.Group>
  );
};

export default CardLimits;
